import React, { useEffect, useState, useRef } from "react";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import socket from "../Components/socket";
import "../css/landing.css";
import Rightcontainer from "../Components/Rightcontainer";
import Downloadbutton from "../Components/Downloadbutton";
import io from "../Components/socket";
import Header from "../Components/Header";
import { Token } from "@mui/icons-material";

export default function Landing({ userAllData }) {
  const [open, setOpen] = useState(false);
  // const [userAllData, setUserAllData] = useState()

  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);
  const udata = JSON.parse(localStorage.getItem("udata"));

  // console.log(addCaseSetting);

  // const role = async () => {
  //   const access_token = localStorage.getItem('token')
  //   io.emit('getprofile', access_token)
  //   io.on('setProfile', data => {
  //     // setUserAllData(data)
  //   })
  // }

  useEffect(() => {
    // role()
  }, []);

  return (
    <>
      <div className="leftContainer mb_space">
        <div className="pt-4  Orher_page_main_section">
          <div className="main-area">
            <div className="gameCard pt-2">
              <div className="alrt_msg_div">
                <h5 className="">
                  {JSON.parse(localStorage.getItem("sitSetting")) == "undefined"
                    ? ""
                    : JSON.parse(localStorage.getItem("sitSetting"))
                        ?.site_message}
                </h5>
              </div>
            </div>

            {/* <div className="collapseCard-container pt-0">
              {udata?.verified == 'unverified' && (
                <div className="collapseCard">
                  <Link to="/Profile">
                    <div className="collapseCard-body">
                      <div className="collapseCard-text text-dark">
                        <span className="text-danger">Please Complete Your KYC</span>
                      </div>
                    </div>
                  </Link>
                </div>
              )}
            </div> */}
            <div
              className="d-flex  mt-3 mb-0"
              style={{ justifyContent: "center" }}
            >
              <h3 className="tour_heading">Discover What We</h3>

              {/* <a className='text-dark text-right btn-youtube-1' href=""> <img  src="/images/youtube.png" />Youtube</a> */}
            </div>
            <div className="">
              <img
                className="w-100"
                src={"./mainimage/Baner.jpg"}
                alt=""
              />
            </div>
            <section className="games-section">
              <div className="games-section-headline mt-0 mb-1">
                <div className="games-window ">
                  <>
                    {/* =================Ludo Classic================ */}

                    <Link
                      className="gameCard-container mb-3"
                      to={`/Homepage/ludoClassicManual`}
                    >
                      <span className="d-none text-danger blink d-block text-right game_status_live">
                        ◉ LIVE
                      </span>
                      <picture className="gameCard-image">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "./mainimage/ludo-classic.jpg"
                          }
                          alt=""
                        />
                      </picture>
                    </Link>

                    {/* =================Ludo snake================ */}
                    {/* <Link className='gameCard-container' to={`/Homepage/LudoSnake`}
                    >
                      <span className='d-none blink text-danger d-block text-right game_status_live'>
                        ◉ Live
                      </span>
                      
                      <picture className='gameCard-image'>
                        <img
                          width='100%'
                          src={
                            process.env.PUBLIC_URL +
                            './mainimage/snake.jpg'
                          }
                          alt=''
                        />
                      </picture>
                    </Link> */}

                    {/* <Link
                      className='gameCard-container'
                      to={`#`}
                    >
                      <span className='d-none blink text-danger d-block text-right game_status_live'>
                        ◉ Comming Soon
                      </span>
                      <picture className='gameCard-image'>
                        <img
                          width='100%'
                          src={
                            process.env.PUBLIC_URL +
                            './mainimage/rummy.jpg'
                          }
                          alt=''
                        />
                      </picture>
                    </Link> */}
                    {/* =================Ludo Lite Classic================ */}
                    {/* <Link className='gameCard-container mb-3'
                  to={`/Homepage/Ludo%20Lite`}>
                  <span className='d-none blink text-success d-block text-right game_status_live'>
                    ◉ LIVE
                  </span>
                  <picture className='gameCard-image'>
                    <img
                     
                      src={
                        process.env.PUBLIC_URL +
                        './mainimage/ludo-lite-classic.jpg'
                      }
                      alt=''
                    />
                  </picture>
                </Link> */}
                    {/* =================Aviator================ */}
                    {/* <Link className='gameCard-container'
                  to={`#`}>
                  <span className='d-none blink text-danger d-block text-right game_status_live'>
                    ◉ COMMING SOON
                  </span>
                  <picture className='gameCard-image'>
                    <img
                     
                      src={
                        process.env.PUBLIC_URL +
                        './mainimage/aviator.jpg'
                      }
                      alt=''
                    />
                  </picture>
                </Link> */}
                    {/* =================Color Pridection================ */}
                    {/* <Link className='gameCard-container'
                  to={`#`}>
                  <span className='d-none blink text-danger d-block text-right game_status_live'>
                    ◉ COMMING SOON
                  </span>
                  <picture className='gameCard-image'>
                    <img
                     
                      src={
                        process.env.PUBLIC_URL +
                        './mainimage/color.jpg'
                      }
                      alt=''
                    />
                  </picture>
                </Link>
                */}
                    {/* =================Ludo Snake================ */}

                    {/* =================Ludo rummy================ */}
                    <a
                      className="gameCard-container"
                      href={
                        JSON.parse(localStorage.getItem("sitSetting")) ==
                        "undefined"
                          ? ""
                          : JSON.parse(localStorage.getItem("sitSetting"))
                              ?.whatsappSupport
                      }
                      target="_blank"
                    >
                      <span className="d-none blink text-danger d-block text-right game_status_live">
                        ◉ LIVE
                      </span>
                      <picture className="gameCard-image">
                        <img
                          width="100%"
                          src={
                            process.env.PUBLIC_URL + "./mainimage/support.jpg"
                          }
                          alt=""
                        />
                      </picture>
                    </a>
                    {/* <Link className="gameCard-container" to={`/Homepage/Ludo%20Ulta`} > */}
                  </>
                </div>
              </div>
            </section>

            <div className="downloadButton">
              <Downloadbutton />
            </div>
          </div>
        </div>
      </div>
      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </>
  );
}
